import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';

export type StatusChipTone = 'default' | 'neutral' | 'success' | 'warning' | 'danger';

@Component({
  selector: 'app-status-chip',

  imports: [CommonModule],
  templateUrl: './status-chip.component.html',
  styleUrl: './status-chip.component.scss',
})
export class StatusChipComponent {
  label = input.required<string>();
  tone = input<StatusChipTone>('default');
  compact = input(false);
}
